import type { ReactNode } from "react";
import { tw } from "../../styling";

type Props = {
	children: ReactNode;
	row?: boolean;
	spaceBetween?: boolean;
	align?: "start" | "end";
};

export const ButtonGroup = ({ children, row = false, spaceBetween, align = "end" }: Props) => {
	const classes = tw(
		// todo: get rid of [a] child selector when buttons support responsive props
		`flex w-full flex-col gap-3 print:hidden [&>a]:w-auto!`,
		row && "tablet:flex-row-reverse tablet:items-center",
		spaceBetween && "justify-between",
		align === "start" && "justify-end", // todo: ugly but we need to support two alignments without breaking old components
	);

	return <div className={classes}>{children}</div>;
};
